import { BaseCarouselTracking } from './BaseCarouselTracking';

export class NewsCarouselTracking extends BaseCarouselTracking {
    aalink = [];
    fathom = [];
    element = null;
    carousel_num = 0;
    link = null;
    url = '';
    constructor(aalink, fathom, elem, num, link) {
        super(aalink, fathom, elem, num, link);
        this.aalink = aalink;
        this.fathom = fathom;
        this.element = elem;
        this.carousel_num = num;
        this.link = link;
        this.url = link.getAttribute('href');
    }
    parse() {
        let channel = this.aalink[4] ?? 'undefined';
        // TODO Hard-coding CBS News Local channels until we can backtrace and fix data
        // change to force rebuild
        channel = channel === 'CBS News' ? 'CBS News Local' : channel;
        let obj = {
            regionalCode: this.aalink[0].toString(),
            rowHeaderTitle: unescape(super.getCleanTitle()),
            posColNum: Number(this.aalink[3]).toString(),
            posRowNum: super.getPosRowNum(),
            contentBrand: this.aalink[10],
            liveTvChannel: channel,
            channelCode: this.aalink[0] === 'on now' ? this.aalink[16] : 'undefined',
            ctaText: this.aalink[2],
            showBadgeLabel: this.aalink[5], //label on the API?
            showSeriesId: this.aalink[11] !== '-1' ? this.aalink[11] : '', //removed
            showSeriesTitle: this.aalink[4], //removed
            targetURL: this.url,
            targetType: this.aalink[2] + '|' + this.url
        };
        return Object.keys(obj)
            .filter((k) => obj[k] !== '')
            .reduce(
                (a, k) => ({
                    ...a,
                    [k]: obj[k]
                }),
                {}
            );
    }
}
